import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { CLEARING_ENABLED } from '@uc/web/config';

export const validateClearingGuard = (route: ActivatedRouteSnapshot) => {
	const router = inject(Router);

	const uniSlug = route.queryParams['uni'];
	const isClearingEnabled = CLEARING_ENABLED;

	if (!isClearingEnabled) {
		router.navigate(['/courses', 'undergraduate'], {
			queryParams: { uni: uniSlug },
			queryParamsHandling: 'merge',
		});

		return false;
	}

	return true;
};
